module.exports = __webpack_public_path__ + "img/img_cx6_open.b4ad62dd.jpg";